import React from 'react';
import { Group, Text, Select, Pagination } from '@mantine/core';

const TablePagination = ({ 
  totalCount, 
  page, 
  pageSize, 
  onPageChange, 
  onPageSizeChange,
  dataLength 
}) => {
  if (!totalCount || totalCount <= 0) return null;

  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="flex items-center justify-between mt-4 p-4 bg-white border border-gray-100 rounded-xl shadow-sm">
      {/* Left Side: Stats & Page Size */}
      <Group spacing="xl">
        <Text size="sm" color="dimmed">
          Showing <b className="text-gray-700">{dataLength}</b> of <b className="text-gray-700">{totalCount}</b> results
        </Text>
        
        <Group spacing={8}>
          <Text size="xs" color="dimmed" weight={500}>Rows per page:</Text>
          <Select
            size="xs"
            data={["10", "20", "50"]}
            value={pageSize.toString()}
            onChange={(val) => onPageSizeChange(parseInt(val))}
            variant="filled"
            styles={{ 
              input: { 
                width: 65, 
                fontWeight: 700, 
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0' 
              } 
            }}
          />
        </Group>
      </Group>

      {/* Right Side: Navigation */}
      <Pagination
        page={page}
        onChange={onPageChange}
        total={totalPages}
        radius="md"
        size="sm"
        withEdges
        styles={(theme) => ({
          item: {
            border: '1px solid #e2e8f0',
            color: '#64748b',
            '&[data-active]': {
              backgroundColor: "#64748B", // Your brand color
              border: 0,
              color: 'white',
              fontWeight: 700
            },
            '&:hover': {
              backgroundColor: '#f1f5f9'
            }
          },
        })}
      />
    </div>
  );
};

export default TablePagination;